import styled from 'styled-components';
import { Button } from '../../../components/antd/Button';

export const VerifyContainer = styled.div`
  max-width: 500px;
  margin: 0 auto;
  padding: 40px 20px;
`;

export const Title = styled.h2`
  text-align: center;
  font-size: 28px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 16px;
`;

export const Description = styled.p`
  text-align: center;
  font-size: 14px;
  color: #7f8c8d;
  margin-bottom: 32px;
  line-height: 1.6;
`;

export const ButtonContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LinkButton = styled(Button)`
  color: #1890ff;
  font-size: 14px;
  padding: 0;
  height: auto;

  &:hover {
    color: #40a9ff;
  }

  &:disabled {
    color: #d9d9d9;
  }
`;
